import { useQuery } from "@tanstack/react-query";
import { tenantsQuery } from "../queries";

export interface UseTenantsOptions {
  authenticatedFetch: (url: string, init?: RequestInit) => Promise<Response>;
  directoryBaseUrl: string;
  enabled?: boolean;
}

export function useTenants(options: UseTenantsOptions) {
  const { enabled = true, ...config } = options;

  return useQuery({
    ...tenantsQuery(config),
    enabled,
    staleTime: 10 * 60 * 1000, // 10 minutes
    gcTime: 15 * 60 * 1000, // 15 minutes
    refetchOnWindowFocus: true,
  });
}
